import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AdminLayout } from '../components/layout/AdminLayout';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { Login } from '../pages/auth/Login';
import { Dashboard } from '../pages/Dashboard';
import { ClientasList } from '../pages/clientas/ClientasList';
import { ClientaForm } from '../pages/clientas/ClientaForm';
import { ServiciosList } from '../pages/servicios/ServiciosList';
import { ServicioForm } from '../pages/servicios/ServicioForm';
import { Agenda } from '../pages/agenda/Agenda';
import { ProductosList } from '../pages/productos/ProductosList';
import { ProductoForm } from '../pages/productos/ProductoForm';
import { InventarioMovimientos } from '../pages/inventario/InventarioMovimientos';
import { VentasList } from '../pages/ventas/VentasList';
import { VentaForm } from '../pages/ventas/VentaForm';
import { ProfesionalesList } from '../pages/profesionales/ProfesionalesList';
import { ProfesionalForm } from '../pages/profesionales/ProfesionalForm';
import { Reportes } from '../pages/reportes/Reportes';
import { Portal } from '../pages/portal/Portal';
import { PoliticaDatos, Terminos } from '../pages/portal/Legal';
import { GastosList } from '../pages/gastos/GastosList';
import { Caja } from '../pages/caja/Caja';
import { ProveedoresList } from '../pages/proveedores/ProveedoresList';
import { ProveedorForm } from '../pages/proveedores/ProveedorForm';
import { ComprasList } from '../pages/compras/ComprasList';
import { CompraForm } from '../pages/compras/CompraForm';
import { CuentasPorPagar } from '../pages/compras/CuentasPorPagar';
import { Cartera } from '../pages/cartera/Cartera';
import { Comisiones } from '../pages/comisiones/Comisiones';
import { EsquemasRemuneracion } from '../pages/comisiones/EsquemasRemuneracion';
import { PagosEmpleados } from '../pages/pagos-empleados/PagosEmpleados';
import { UsuariosList } from '../pages/usuarios/UsuariosList';
import { AuditoriaList } from '../pages/auditoria/AuditoriaList';
import { ROLES } from '../lib/roles';

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/admin" replace /> },
  { path: '/login', element: <Login /> },
  { path: '/portal', element: <Portal /> },
  { path: '/portal/politica-datos', element: <PoliticaDatos /> },
  { path: '/portal/terminos', element: <Terminos /> },
  {
    path: '/admin',
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'agenda', element: <Agenda /> },
      { path: 'clientas', element: <ClientasList /> },
      { path: 'clientas/:id', element: <ClientaForm /> },
      // 'servicios' queda abierta a cualquier usuario autenticado (staff y
      // profesional consultan el catálogo por igual, DAF v2 §5.3); solo la
      // edición se restringe -- ver ServiciosList.tsx.
      { path: 'servicios', element: <ServiciosList /> },
      {
        path: 'servicios/:id',
        element: (
          <ProtectedRoute roles={[ROLES.ADMIN]}>
            <ServicioForm />
          </ProtectedRoute>
        ),
      },
      {
        path: 'profesionales',
        element: (
          <ProtectedRoute roles={[ROLES.ADMIN, ROLES.RECEPCION]}>
            <ProfesionalesList />
          </ProtectedRoute>
        ),
      },
      {
        path: 'profesionales/:id',
        element: (
          <ProtectedRoute roles={[ROLES.ADMIN, ROLES.RECEPCION]}>
            <ProfesionalForm />
          </ProtectedRoute>
        ),
      },
      { path: 'ventas', element: <VentasList /> },
      { path: 'ventas/nueva', element: <VentaForm /> },
      { path: 'cartera', element: <Cartera /> },
      // 'productos' queda abierta a cualquier usuario autenticado: la
      // propia pantalla (ProductosList) decide qué mostrar según el rol
      // -- catálogo completo para staff, solo lo disponible para venta
      // (vía productos_disponibles_venta()) para profesional.
      { path: 'productos', element: <ProductosList /> },
      {
        path: 'productos/:id',
        element: (
          <ProtectedRoute roles={[ROLES.ADMIN, ROLES.RECEPCION]}>
            <ProductoForm />
          </ProtectedRoute>
        ),
      },
      {
        path: 'inventario',
        element: (
          <ProtectedRoute roles={[ROLES.ADMIN, ROLES.RECEPCION]}>
            <InventarioMovimientos />
          </ProtectedRoute>
        ),
      },
      { path: 'proveedores', element: <ProveedoresList /> },
      { path: 'proveedores/:id', element: <ProveedorForm /> },
      { path: 'compras', element: <ComprasList /> },
      { path: 'compras/nueva', element: <CompraForm /> },
      { path: 'compras/cuentas-por-pagar', element: <CuentasPorPagar /> },
      { path: 'gastos', element: <GastosList /> },
      { path: 'caja', element: <Caja /> },
      {
        path: 'comisiones',
        element: (
          <ProtectedRoute roles={[ROLES.ADMIN]}>
            <Comisiones />
          </ProtectedRoute>
        ),
      },
      {
        path: 'comisiones/esquemas',
        element: (
          <ProtectedRoute roles={[ROLES.ADMIN]}>
            <EsquemasRemuneracion />
          </ProtectedRoute>
        ),
      },
      { path: 'pagos-empleados', element: <PagosEmpleados /> },
      { path: 'reportes', element: <Reportes /> },
      {
        path: 'usuarios',
        element: (
          <ProtectedRoute roles={[ROLES.ADMIN]}>
            <UsuariosList />
          </ProtectedRoute>
        ),
      },
      {
        path: 'auditoria',
        element: (
          <ProtectedRoute roles={[ROLES.ADMIN]}>
            <AuditoriaList />
          </ProtectedRoute>
        ),
      },
    ],
  },
  { path: '*', element: <Navigate to="/admin" replace /> },
]);
